// Import the functions you need from the SDKs you need
//import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

//import '@firebase/firestore'
//import { getFireStore } from "firebase/firestore";


// The above lines are commented out and replaced with the following (cf https://stackoverflow.com/a/69065645)
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
require('firebase/auth');
require('firebase/firestore');

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD-iUcHrfENPWnJuFUjvBP0mmOe-tgf0zE",
  authDomain: "fb-mock-4.firebaseapp.com",
  projectId: "fb-mock-4",
  storageBucket: "fb-mock-4.appspot.com",
  messagingSenderId: "774147880072",
  appId: "1:774147880072:web:d28bbff03cce1fa9229b3d",
  measurementId: "G-89HYEE0CDN"
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


export const auth = getAuth(app)
export const db = app.firestore()

export const Timestamp = firebase.firestore.Timestamp
export const FieldValue = firebase.firestore.FieldValue

export default app